import { render } from "./QuoteFilter.vue?vue&type=template&id=15ff64d6&scoped=true"
import script from "./QuoteFilter.vue?vue&type=script&lang=js"
export * from "./QuoteFilter.vue?vue&type=script&lang=js"

import "./QuoteFilter.vue?vue&type=style&index=0&id=15ff64d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ff64d6"]])

export default __exports__